import React from "react";

const Dashboard = () => {
  return (
    <div className="text-center items-center mt-36 justify-center  max-w-sm p-6  text-white bg-gray-800 rounded-lg shadow-lg mx-auto ">
      <img
        className="h-28 w-28 rounded-full mx-auto mb-4"
        src="/images/logo.png"
        alt="Vamagems"
        title="Vamagems"
      />
      <h1 className="text-3xl font-bold mb-2">Welcome to the Dashboard</h1>
    </div>
  );
};

export default Dashboard;
